<template>
	<div class="pay-record-detail-container">
		<div class="content">
			<div class="card-wrapper">
				<mobile-card>
					<template slot="title">支付信息</template>

					<template slot="content">
						<div class="flex-form-info">
							<span>订单编号</span>
							<span>{{selectRecord.orderNo | formatSpaceText}}</span>
						</div>
						<div class="flex-form-info">
							<span>订单状态</span>
							<span>{{selectRecord.stateStr | formatSpaceText}}</span>
						</div>
						<div class="flex-form-info">
							<span>订单金额</span>
							<span class="money-item">{{selectRecord.money | formatMoney}}</span>
						</div>
						<div class="flex-form-info">
							<span>创建时间</span>
							<span>{{selectRecord.createTime | formatSpaceText}}</span>
						</div>
						<div class="flex-form-info">
							<span>支付方式</span>
							<span>{{selectRecord.payType | formatSpaceText}}</span>
						</div>
						<div class="flex-form-info">
							<span>支付时间</span>
							<span>{{selectRecord.payTime | formatSpaceText}}</span>
						</div>

						<div class="flex-form-info">
							<span>发票抬头</span>
							<span>{{selectRecord.ticketTitle | formatSpaceText}}</span>
						</div>
					</template>
				</mobile-card>
			</div>
			<div class="card-wrapper">
				<mobile-card>
					<template slot="title">订单明细</template>

					<template slot="content">
						<div v-for="(item, index) in payDetail" :key="index">
							<div class="flex-form-info">
								<!-- <span>{{item.name}}</span>
								<span class="money-item">{{item.money | formatMoney}}</span> -->
								<!-- <span>{{`${item.intervalName}${item.itemName}`}}</span> -->
								<span>{{ getOrderText(item) }}</span>
								<span class="money-item">{{item.payMoney | formatMoney}}</span>
							</div>
						</div>
					</template>
				</mobile-card>

			</div>
		</div>

		<!-- <van-button type="default" class="btn-back" @click="onBack">返回上一级</van-button> -->
		<div class="footer">
			<div class="footer-bar">
				<mobile-button color="#005423" @click="onBack">返回上一级</mobile-button>
			</div>
		</div>
	</div>
</template>

<script>
	import log from "utils/log";
	import MobileCard from "components/mobile-card/index";
	import MobileButton from "components/mobile-button/index";
	// import { getState } from "utils/state";
	import storage from 'good-storage'
	import apiPayRecord from "api/pay-record";
	import utils from "@/utils/util";

	export default {
		name:'payRecordDetail',
		components: { MobileButton,MobileCard },

		data() {
			return {
				selectRecord: {}
			};
		},
		
		computed: {
			payDetail() {
				log("details", this.selectRecord.details);
				return this.selectRecord.details;
			}
		},

		activated() {
			this.getRecord();
		},

		methods: {
			getRecord() {
				// let r = getState("select-record");
				let r = storage.session.get("select-record",{});
				log("select record ", r);
				if (utils.isEmpty(r)) {
					this.$router.push("/home");
					return;
				}

				let param = {
					orderNo: r.orderNo,
					outPayNo: r.outPayNo
				};

				apiPayRecord.detail(param).then(res => {
					let d = res.data;
					if (utils.isNotEmpty(d)) {
						this.selectRecord = d;
					}
				});
			},

			getOrderText(item) {
				let s = ''
                if (item.intervalName) {
                    s = `${item.intervalName}  `
                    if (item.itemName) {
                        let s2 = `${ item.itemName }`
                        s += s2
                    }
				} else {
                    if (item.itemName) {
                        let s2 = `${ item.itemName }`
                        s += s2
                    }
				}
				return s
			},

			onBack() {
				this.$router.back();
			}
		},
	};
</script>

<style lang='scss' scoped>
	// .flex-form-info {
	// 	padding: 5px;
	// 	display: flex;
	// 	justify-content: space-between;
	// }

	// .money-item {
	// 	color: #3b7a53;
	// }

	// .btn-back {
	// 	font-size: 16px;
	// 	font-weight: bold;
	// 	border: 1px solid #d1d1d1;
	// 	background-color: #f4f4f5;
	// 	border-radius: 5px;
	// 	margin-left: 8px;
	// 	color: #005423;
	// }
</style>
